module.exports = __webpack_public_path__ + "img/asana_extractor.dd216cf1.png";